import { Box, useTheme } from "@mui/material";
import { navLinks } from "../NavLinks.data";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function NavLinks({ activeId, onSelect }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const { role } = useSelector((state) => state.userSlice);

  // Use the actual current URL as the source of truth
  const currentPath = location.pathname;

  const handleNavigate = (id, href) => {
    onSelect?.(id);
    navigate(href);
  };

  const NavItem = ({ id, href, label }) => {
    // Route is active based on URL
    const isActive = currentPath === href;

    return (
      <Box
        component="a"
        href={href}
        onClick={(e) => {
          e.preventDefault();
          handleNavigate(id, href);
        }}
        sx={{
          position: "relative",
          textDecoration: "none",
          fontWeight: 500,
          fontSize: 14.5,
          padding: "9px 16px",
          borderRadius: 999,

          color: isActive ? "#fff" : "text.secondary",

          transition: "color .2s ease, box-shadow .2s ease",
          whiteSpace: "nowrap",

          ...(!isActive && {
            "&:hover": {
              boxShadow: (t) => `inset 0 0 0 1px ${t.palette.primary.main}20`,
            },
          }),
        }}
      >
        {isActive && (
          <Box
            component="span"
            sx={{
              position: "absolute",
              inset: 0,
              borderRadius: "999px",
              bgcolor: "primary.main",
              zIndex: 0,
            }}
          />
        )}

        <Box
          component="span"
          sx={{
            position: "relative",
            zIndex: 1,
          }}
        >
          {label}
        </Box>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: { xs: "none", md: "flex" },
        alignItems: "center",
        flexDirection: "row-reverse",
        gap: 0.25,
      }}
    >
      {/* Normal links */}
      {navLinks.map((link) => {
        if (link.notPrint) return null;

        return (
          <NavItem
            key={link.id}
            id={link.id}
            href={link.href}
            label={link.label}
          />
        );
      })}

      {/* Provider */}
      {role === "provider" && (
        <NavItem
          id="/finding-project"
          href="/finding-project"
          label="دریافت سفارش"
        />
      )}

      {/* Customer */}
      {role === "customer" && (
        <NavItem
          id="/profile/orders"
          href="/profile/orders"
          label="سفارشات من"
        />
      )}
    </Box>
  );
}
